import { FC, PropsWithChildren, memo, useCallback } from 'react';
import { ButtonWrapper } from '@tempusfinance/common-ui';
import LoadingIndicator from '../LoadingIndicator';
import { LoadingColor } from '../LoadingIndicator/LoadingIndicator';

import './ButtonSecondary.scss';

interface ButtonSecondaryProps {
  onClick?: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  loadingColor?: LoadingColor;
  size?: 'sm' | 'lg';
}

const ButtonSecondaryComponent: FC<PropsWithChildren<ButtonSecondaryProps>> = ({
  children,
  fullWidth = false,
  disabled = false,
  loading = false,
  loadingColor = 'default',
  size = 'sm',
  onClick,
}) => {
  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <ButtonWrapper onClick={handleClick} fullWidth={fullWidth} disabled={disabled || loading}>
      <div
        className="nostra__buttonSecondary"
        data-loading={loading}
        data-full-width={fullWidth}
        data-disabled={disabled}
        data-size={size}
      >
        {loading && (
          <div className="nostra__buttonSecondary__loading">
            <LoadingIndicator size={16} color={loadingColor} />
          </div>
        )}
        {children}
      </div>
    </ButtonWrapper>
  );
};
export const ButtonSecondary = memo(ButtonSecondaryComponent);
